<div class="mfaListHeader">
  <h2 mat-dialog-title>{{ 'account.dialogs.mfa.management.title' | t }}</h2>
  <sn-icon-button [matTooltip]="'common.refresh' | t" (click)="reloadData()">
    <sn-icon fontIcon="fa-redo-alt" fontSet="fal"></sn-icon>
  </sn-icon-button>
</div>
<mat-dialog-content>
  <sn-data-list #list [fetchFn]="loadData">
    <sn-infinite-scroll>
      <sn-pull-to-refresh>
        <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="table"></ng-template>
        <ng-template
          [ngIf]="!list.dataSource.data.length && list.dataIsInited"
          [ngIfThen]="emptyList"
        ></ng-template>
      </sn-pull-to-refresh>
    </sn-infinite-scroll>
  </sn-data-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" mat-dialog-close>{{ 'common.cancel' | t }}</button>
  <button *ngIf="list.dataSource.data.length" mat-button color="accent" (click)="seeBackupCodes()">
    {{ 'account.dialogs.mfa.management.seeBackupCodes' | t }}
  </button>
  <button mat-button color="success" (click)="addAccount()">{{ 'account.dialogs.mfa.management.setUpMfa' | t }}</button>
</mat-dialog-actions>

<ng-template #table>
  <sn-mfa-table
    [columns]="columns"
    [actions]="actions"
    [items]="list.dataSource.data"
    [sort]="sort"
    [sortDirection]="sortDirection"
    (sortChange)="onSortChange($event)"
  >
  </sn-mfa-table>
</ng-template>

<ng-template #emptyList>
  <sn-empty-state fontSet="fal" fontIcon="fa-shield-xmark" title="{{ 'common.noResults' | t }}">
    {{ 'account.dialogs.mfa.management.noResults' | t }}
  </sn-empty-state>
</ng-template>
